export const ConfirmBonificoDraftScreenPath =
  "/admin/bonifico/confirm/:orderId";

export function toConfirmBonificoDraftPath(orderId: string): string {
  return ConfirmBonificoDraftScreenPath.replace(":orderId", orderId);
}
